import * as React from "react";
import * as ReactDOM from "react-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';
import AppRoutes from '../AppRoutes';
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../features/userSlice";
import { setSidebarCollapsed, clearSidebarCollapsed } from "../features/SidebarCollapseSlice";

import logo from '../assets/images/sidebar-logo.png';
import logoSmall from '../assets/images/sidebar-logo-collapsed.png';
import chevronLeft from '../assets/images/angle-left-small.svg';
import chevronRight from '../assets/images/angle-right-small.svg';
import logOutIcon from '../assets/images/log-out.svg';
const { useState, useEffect } = React;


export const Sidebar = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const reduxIsSidebarCollapsed = useSelector(state => state.isSideBarCollapsed.sidebarCollapsed);

    const useMediaQuery = (query) => {
        const [matches, setMatches] = useState(false);

        useEffect(() => {
            const media = window.matchMedia(query);
            if (media.matches !== matches) {
                setMatches(media.matches);
            }
            const listener = () => setMatches(media.matches);
            window.addEventListener("resize", listener);
            return () => window.removeEventListener("resize", listener);
        }, [matches, query]);
        return matches;
    };

    const handleLogout = () => {
        dispatch(clearSidebarCollapsed());
        dispatch(logout());
    }

    const minimizeSidebar = () => {
        if (reduxIsSidebarCollapsed == false) {
            dispatch(setSidebarCollapsed(true));
        }
        else {
            dispatch(clearSidebarCollapsed());
        }
    }

    const createCounterElement = () => {
        return { __html: `<span class="counter">2</span>` };
    }
    let menuItems = AppRoutes;

    return (
        <div className={`sidebar ${reduxIsSidebarCollapsed == true && "sidebar-collapsed"}`}>
            <button className="btn-collapse" onClick={minimizeSidebar}>
                {
                    reduxIsSidebarCollapsed == true ?
                        <img src={chevronRight} /> :
                        <img src={chevronLeft} />
                }
            </button>
            <NavLink tag={Link} to="/" className="logo-link">
                {
                    reduxIsSidebarCollapsed == true ?
                        <img src={logoSmall}></img>
                        : <img src={logo}></img>
                }
            </NavLink>
            <div className="boxicon-container">
                {menuItems.map((item, index) => {
                    if (item.path == "/booking") {
                        return;
                    }

                    var imageName = require('../assets/images/' + item.icon + '-black.png');
                    if (location.pathname === item.path) {
                        var imageName = require('../assets/images/' + item.icon + '-red.png');
                    }
                    if (item.path == "/properties" || item.path == "/agents") {
                        return (
                            <NavLink tag={Link} to={item.path} className={`menu-link ${location.pathname === item.path && "active"}`} key={index} disabled>
                                <span className={` ${reduxIsSidebarCollapsed == false && "d-flex justify-content-between align-items-center"}`}>
                                    <span>
                                        <img src={imageName} alt={`menu-icon` + item.name} />
                                        <span className={`description ${reduxIsSidebarCollapsed == true && "d-none"}`}>{item.name}</span>
                                    </span>
                                    {
                                        item.path == "/" ?
                                            //<span className={`count-container ${reduxIsSidebarCollapsed == true && "d-none"}`} dangerouslySetInnerHTML={createCounterElement()} ></span>
                                            <span className={`count-container ${reduxIsSidebarCollapsed == true && "d-none"}`} ></span>
                                            : ""
                                    }
                                </span>
                            </NavLink>
                        );
                    }
                    else {
                        return (
                            <NavLink tag={Link} to={item.path} className={`menu-link ${location.pathname === item.path && "active"}`} key={index}>
                                <span className={` ${reduxIsSidebarCollapsed == false && "d-flex justify-content-between align-items-center"}`}>
                                    <span>
                                        <img src={imageName} alt={`menu-icon` + item.name} />
                                        <span className={`description ${reduxIsSidebarCollapsed == true && "d-none"}`}>{item.name}</span>
                                    </span>
                                    {
                                        item.path == "/" ?
                                            //<span className={`count-container ${reduxIsSidebarCollapsed == true && "d-none"}`} dangerouslySetInnerHTML={createCounterElement()} ></span>
                                            <span className={`count-container ${reduxIsSidebarCollapsed == true && "d-none"}`}></span>
                                            : ""
                                    }
                                </span>
                            </NavLink>
                        );
                    }
                })}

                <button className="menu-link nav-link logout" onClick={handleLogout}>
                    <span className={` ${reduxIsSidebarCollapsed == false && "d-flex justify-content-between"}`}>
                        <span>
                            <img src={logOutIcon} alt="logout-icon" />
                            <span className={`description ${reduxIsSidebarCollapsed == true && "d-none"}`}>Logout</span>
                        </span>
                    </span>
                </button>
            </div>
        </div>
    );
};